import React, { useEffect, useState, useContext } from "react";
import { Container, Grid, Card, Typography, Box } from "@mui/material";
import { NavLink, useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { axiosInstance } from "../Api/instance";
import { UserContext } from "../../Context";
import { PageHeader } from "../ui/PageHeaders";

const PageWrapper = styled(Box)(({ theme }) => ({
  minHeight: "100vh",
  padding: "40px 0",
  background: theme.palette.mode === "light"
    ? "linear-gradient(135deg, #F8FAFC 0%, #EFF6FF 100%)"
    : "linear-gradient(135deg, #0B0F19 0%, #111827 100%)",
}));

const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: "20px",
  padding: "24px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  minHeight: "200px",
  cursor: "pointer",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
  height: "100%",
  "&:hover": {
    transform: "translateY(-6px)",
    boxShadow: theme.palette.mode === "light"
      ? "0 12px 24px rgba(30, 58, 138, 0.08)"
      : "0 12px 24px rgba(0, 0, 0, 0.4)",
    borderColor: theme.palette.primary.main,
  },
}));

const ImageContainer = styled(Box)(({ theme }) => ({
  width: "80px",
  height: "80px",
  borderRadius: "18px",
  backgroundColor: theme.palette.mode === "light" ? "#F1F5F9" : "#1F2937",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "20px",
  overflow: "hidden",
  padding: "10px",
  transition: "transform 0.3s ease",
  [`${StyledCard}:hover &`]: {
    transform: "scale(1.08)",
  },
}));

export default function YearMCQ() {
  const [data, setData] = useState([]);
  const { Endpoint } = useContext(UserContext);
  const email = localStorage.getItem("userMail");
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    try {
      const response = await axiosInstance.post(
        `get/U_ViewPmcqInstitution.php`,
        {
          userId: email,
        }
      );
      if (response.status === 200) {
        if (response.data.message === "timeout") {
          navigate("/signin");
        }

        const obj = response.data.map((data) => ({
          img: `${Endpoint}/controllers/api/admin/upload/${data.img}`,
          name: data.institution_name,
          path: `/instruction/${data.sno}`,
          sno: data.sno,
        }));
        setData(obj);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <PageWrapper>
      <Container maxWidth="lg">
        <PageHeader 
          title="Previous Year MCQ" 
          subtitle="Explore past examination question papers and keys"
          onBack={() => navigate("/home")} 
        />
        <Grid container spacing={3} style={{ marginTop: "8px" }}>
          {data.map((d) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={d.sno}>
              <NavLink to={d.path} style={{ textDecoration: "none", color: "inherit" }}>
                <StyledCard>
                  <ImageContainer>
                    <img 
                      src={d.img} 
                      alt={d.name} 
                      style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} 
                    />
                  </ImageContainer>
                  <Typography variant="h3" style={{ fontWeight: 700, fontSize: "1.1rem" }}>
                    {d.name}
                  </Typography>
                </StyledCard>
              </NavLink>
            </Grid>
          ))}
        </Grid>
      </Container>
    </PageWrapper>
  );
}
